const mobileScreenWidth = 768;

class Breakpoints {
    static get mobileScreenWidth() {
        return mobileScreenWidth;
    }
}

export {Breakpoints as default}



// WEBPACK FOOTER //
// ../utils/breakpoints.js